module.exports = __webpack_public_path__ + "components/about-header/static/header--medium@2x-5d37db22a044ea6589052a4eae8dab9a.jpg";